/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type {
  AddCurrencyToPouchParams,
  AddCurrencyToPouchRequestBodyBody,
  AddCurrencyToPouchSuccessResponseResponse,
  BboForexManagementBadRequestResponse,
  BboForexManagementFailureResponseResponse,
  BboForexManagementForbiddenResponse,
  BboForexManagementUnauthorizedResponse,
  NotFoundResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary User selects the currency for pouch preparation, and enter total value, along with denomination, if it exist. User clicks "Add" Button and currency will be added to the pouch and status as “In Progress” along with date time.
 */
export const addCurrencyToPouch = (
  addCurrencyToPouchRequestBodyBody: AddCurrencyToPouchRequestBodyBody,
  params?: AddCurrencyToPouchParams,
) => {
  return customInstance<AddCurrencyToPouchSuccessResponseResponse>({
    url: `/BboForexManagementService/v1/AddCurrencyToPouch`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: addCurrencyToPouchRequestBodyBody,
    params,
  });
};

export const getAddCurrencyToPouchMutationOptions = <
  TError = ErrorType<
    | BboForexManagementBadRequestResponse
    | BboForexManagementUnauthorizedResponse
    | BboForexManagementForbiddenResponse
    | NotFoundResponse
    | BboForexManagementFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addCurrencyToPouch>>,
    TError,
    { data: AddCurrencyToPouchRequestBodyBody; params?: AddCurrencyToPouchParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addCurrencyToPouch>>,
  TError,
  { data: AddCurrencyToPouchRequestBodyBody; params?: AddCurrencyToPouchParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addCurrencyToPouch>>,
    { data: AddCurrencyToPouchRequestBodyBody; params?: AddCurrencyToPouchParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return addCurrencyToPouch(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddCurrencyToPouchMutationResult = NonNullable<
  Awaited<ReturnType<typeof addCurrencyToPouch>>
>;
export type AddCurrencyToPouchMutationBody = AddCurrencyToPouchRequestBodyBody;
export type AddCurrencyToPouchMutationError = ErrorType<
  | BboForexManagementBadRequestResponse
  | BboForexManagementUnauthorizedResponse
  | BboForexManagementForbiddenResponse
  | NotFoundResponse
  | BboForexManagementFailureResponseResponse
>;

/**
 * @summary User selects the currency for pouch preparation, and enter total value, along with denomination, if it exist. User clicks "Add" Button and currency will be added to the pouch and status as “In Progress” along with date time.
 */
export const useAddCurrencyToPouch = <
  TError = ErrorType<
    | BboForexManagementBadRequestResponse
    | BboForexManagementUnauthorizedResponse
    | BboForexManagementForbiddenResponse
    | NotFoundResponse
    | BboForexManagementFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addCurrencyToPouch>>,
    TError,
    { data: AddCurrencyToPouchRequestBodyBody; params?: AddCurrencyToPouchParams },
    TContext
  >;
}) => {
  const mutationOptions = getAddCurrencyToPouchMutationOptions(options);

  return useMutation(mutationOptions);
};
